export default (errorMessage: string): string => {
  const errorMessageWithoutDotAtEnd = errorMessage.endsWith(".") ? errorMessage.slice(0, -1) : errorMessage;
  const splitedErrorMessage = errorMessageWithoutDotAtEnd.split(":").pop();
  return splitedErrorMessage ? splitedErrorMessage.trim() : errorMessageWithoutDotAtEnd;
};
